"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.measure = void 0;
var px_1 = require("./px");
var label_1 = require("./label");
var measure = function (ctx, _a) {
    var text = _a.text, _b = _a.labelSize, labelSize = _b === void 0 ? 12 : _b, _c = _a.font, font = _c === void 0 ? label_1.FONT : _c;
    var px = (0, px_1.makePx)(1);
    ctx.font = px(labelSize) + "px " + font;
    return ctx.measureText(text);
};
exports.measure = measure;
